"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageToAll = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EDiveHostCommand = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var diveGameMode_scenario_new_1 = require("@voyage/gamemodes/diveGameMode_scenario_new");
var diveMessages_sidecar_1 = require("@dive/misc/diveMessages-sidecar");
var EDiveHostCommand;
(function (EDiveHostCommand) {
    EDiveHostCommand[EDiveHostCommand["Message"] = 0] = "Message";
    // Reset = 0,
    // Clear = 1,
    // DestroyCrew = 2,
    // LoadScenario = 3,
    EDiveHostCommand[EDiveHostCommand["NewScenario"] = 4] = "NewScenario";
    EDiveHostCommand[EDiveHostCommand["NextLevel"] = 5] = "NextLevel";
    // Resume = 5,
})(EDiveHostCommand = exports.EDiveHostCommand || (exports.EDiveHostCommand = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Dive_HostCommand;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.hostCommand);
    messageWriter_sidecar_1.messageWriter.writeString(m, d.message || '');
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        hostCommand: messageWriter_sidecar_1.messageWriter.read8(m),
        message: messageWriter_sidecar_1.messageWriter.readString(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        hostCommand: EDiveHostCommand.NewScenario,
        message: 'hello, world',
    };
    messageWriter_sidecar_1.messageWriter.test('host-command', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    if (msg.hostCommand === EDiveHostCommand.NewScenario) {
        console.log('!! Dive HOST COMMAND', 'New scenario');
        diveMessages_sidecar_1.diveMessages.setMessage('New Scenario');
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            // TODO: signal host to build new scenario
            voyageGameManager_sidecar_1.voyageGameManager.goScenario_generate_new_scenario();
        }
    }
    if (msg.hostCommand === EDiveHostCommand.NextLevel) {
        console.log('!! Dive HOST COMMAND', 'Next level ');
        diveMessages_sidecar_1.diveMessages.setMessage('New Level');
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            diveGameMode_scenario_new_1.go_dive_newLevel(false, false);
        }
    }
}
exports.process = process;
function sendMessageToAll(msg) {
    websockets_sidecar_1.websockets._sendMessageToAll(write, msg, true);
}
exports.sendMessageToAll = sendMessageToAll;
